import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 0,
  class: "card mb-25 border-0 rounded-0 bg-white letter-spacing"
}
const _hoisted_5 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_6 = { class: "custom-search" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-8" }
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_11 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_12 = { class: "d-sm-flex align-items-center" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = {
  key: 0,
  class: "spinner-border text-white",
  role: "status"
}
const _hoisted_15 = { class: "d-flex align-items-center" }
const _hoisted_16 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_17 = { class: "row mb-20" }
const _hoisted_18 = { class: "col-md-4 mb-10" }
const _hoisted_19 = { class: "col-md-4 mb-10" }
const _hoisted_20 = { class: "col-md-4 mb-10" }
const _hoisted_21 = { class: "col-md-6 d-flex align-items-center justify-content-start mb-1 mb-md-0" }
const _hoisted_22 = {
  key: 0,
  class: "text-warning"
}
const _hoisted_23 = {
  key: 1,
  class: "text-info"
}
const _hoisted_24 = { key: 2 }
const _hoisted_25 = {
  key: 3,
  class: "text-nowrap"
}
const _hoisted_26 = { key: 4 }
const _hoisted_27 = { class: "row" }
const _hoisted_28 = { class: "col-12" }
const _hoisted_29 = { class: "col-12" }
const _hoisted_30 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_31 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_32 = { class: "d-sm-flex align-items-center" }
const _hoisted_33 = ["disabled"]
const _hoisted_34 = {
  key: 0,
  class: "spinner-border text-white",
  role: "status"
}
const _hoisted_35 = { class: "d-flex align-items-center" }
const _hoisted_36 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_37 = { class: "row mb-20" }
const _hoisted_38 = { class: "col-md-6 d-flex align-items-center justify-content-start mb-1 mb-md-0" }
const _hoisted_39 = {
  key: 0,
  class: "text-warning"
}
const _hoisted_40 = {
  key: 1,
  class: "text-info"
}
const _hoisted_41 = { key: 2 }
const _hoisted_42 = {
  key: 2,
  class: "text-nowrap"
}
const _hoisted_43 = { key: 3 }
const _hoisted_44 = { class: "row" }
const _hoisted_45 = {
  class: "col-12",
  md: "6"
}
const _hoisted_46 = {
  class: "col-12",
  md: "6"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_select = _resolveComponent("v-select")!
  const _component_b_form_group = _resolveComponent("b-form-group")!
  const _component_center = _resolveComponent("center")!
  const _component_vue_good_table = _resolveComponent("vue-good-table")!
  const _component_PaginatorContent = _resolveComponent("PaginatorContent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h5", null, _toDisplayString(_ctx.distribution.note_ref), 1),
        _cache[20] || (_cache[20] = _createElementVNode("br", null, null, -1)),
        _createElementVNode("p", null, [
          _cache[16] || (_cache[16] = _createTextVNode(" Date de création : ", -1)),
          (_ctx.distribution.created_at)
            ? (_openBlock(), _createElementBlock("b", _hoisted_3, _toDisplayString(_ctx.getDate(_ctx.distribution.created_at)), 1))
            : _createCommentVNode("", true),
          _cache[17] || (_cache[17] = _createTextVNode(" | ", -1)),
          _createElementVNode("b", null, _toDisplayString(_ctx.distribution.zone_name), 1),
          _cache[18] || (_cache[18] = _createTextVNode(" | ", -1)),
          _createElementVNode("b", null, _toDisplayString(_ctx.distribution.note_city), 1),
          _cache[19] || (_cache[19] = _createTextVNode(" | ", -1)),
          _createElementVNode("b", null, _toDisplayString(_ctx.distribution.note_delivery_name), 1)
        ])
      ])
    ]),
    (_ctx.distribution.note_save == 0 && _ctx.auth.can('BDIS'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _cache[24] || (_cache[24] = _createElementVNode("div", { class: "card-header" }, [
            _createElementVNode("h5", null, "Scan code suivi")
          ], -1)),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("form", {
              onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.SearchColis && _ctx.SearchColis(...args)), ["prevent"]))
            }, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _cache[21] || (_cache[21] = _createElementVNode("label", null, "Code Suivi :", -1)),
                      _withDirectives(_createElementVNode("input", {
                        placeholder: "Code Suivi",
                        type: "text",
                        id: "scanFocus",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.codeColis) = $event)),
                        class: "form-control"
                      }, null, 512), [
                        [_vModelText, _ctx.codeColis]
                      ])
                    ])
                  ]),
                  _cache[22] || (_cache[22] = _createElementVNode("div", { class: "col-md-4" }, [
                    _createElementVNode("button", {
                      class: "btn btn-success me-3 mb-3 mt-3",
                      type: "submit"
                    }, [
                      _createElementVNode("i", { class: "ph ph-scan" })
                    ])
                  ], -1)),
                  _cache[23] || (_cache[23] = _createElementVNode("div", { class: "col-12" }, [
                    _createElementVNode("hr")
                  ], -1))
                ])
              ])
            ], 32)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_10, [
      _cache[37] || (_cache[37] = _createElementVNode("div", { class: "card-header" }, [
        _createElementVNode("h5", null, "List des nouveaux colis")
      ], -1)),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          (_ctx.auth.can('ADD_BDIS'))
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0",
                type: "button",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.addNewColis && _ctx.addNewColis(...args))),
                disabled: _ctx.load_add
              }, [
                (_ctx.load_add)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, _cache[25] || (_cache[25] = [
                      _createElementVNode("span", { class: "visually-hidden" }, "Loading...", -1)
                    ])))
                  : _createCommentVNode("", true),
                _cache[26] || (_cache[26] = _createTextVNode(" Ajouter ", -1)),
                _cache[27] || (_cache[27] = _createElementVNode("i", { class: "flaticon-plus position-relative ms-5 fs-12" }, null, -1))
              ], 8, _hoisted_13))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_15, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.getRows1())),
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.users1.searchTerm) = $event)),
            class: "form-control shadow-none text-black rounded-0",
            placeholder: "Chercher"
          }, null, 544), [
            [_vModelText, _ctx.users1.searchTerm]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          (_ctx.auth.can('FILTER_IN_DISTRIBUTION'))
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("div", _hoisted_18, [
                  _createVNode(_component_b_form_group, null, {
                    default: _withCtx(() => [
                      _cache[28] || (_cache[28] = _createElementVNode("label", null, "Status:", -1)),
                      _createVNode(_component_v_select, {
                        class: "custom-select-height",
                        modelValue: _ctx.status_filter,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.status_filter) = $event)),
                        label: "name",
                        options: _ctx.StatusList
                      }, null, 8, ["modelValue", "options"])
                    ]),
                    _: 1,
                    __: [28]
                  })
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createVNode(_component_b_form_group, null, {
                    default: _withCtx(() => [
                      _cache[29] || (_cache[29] = _createElementVNode("label", null, "Livreur:", -1)),
                      _createVNode(_component_v_select, {
                        class: "custom-select-height",
                        modelValue: _ctx.liv_filter,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.liv_filter) = $event)),
                        label: "name",
                        options: _ctx.LivreurList
                      }, null, 8, ["modelValue", "options"])
                    ]),
                    _: 1,
                    __: [29]
                  })
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("button", {
                    style: {"margin-top":"22px"},
                    class: "btn btn-primary",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.searchFilter()))
                  }, _cache[30] || (_cache[30] = [
                    _createElementVNode("i", { class: "flaticon-search" }, null, -1),
                    _createTextVNode(" Chercher ", -1)
                  ])),
                  _createElementVNode("button", {
                    style: {"margin-top":"22px"},
                    class: "btn btn-warning",
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.removeFilter()))
                  }, _cache[31] || (_cache[31] = [
                    _createElementVNode("i", { class: "flaticon-close" }, null, -1),
                    _createTextVNode(" Annuler ", -1)
                  ]))
                ])
              ], 64))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_21, [
            _cache[32] || (_cache[32] = _createElementVNode("label", null, "Voir", -1)),
            _createVNode(_component_v_select, {
              modelValue: _ctx.users1.per_page,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.users1.per_page) = $event)),
              options: [10, 50],
              clearable: false,
              class: "per-page-selector d-inline-block mx-50",
              onInput: _cache[10] || (_cache[10] = ($event: any) => (_ctx.getRows1()))
            }, null, 8, ["modelValue"]),
            _createElementVNode("label", null, _toDisplayString(_ctx.users1.total) + " entités", 1)
          ])
        ]),
        _createVNode(_component_vue_good_table, {
          columns: _ctx.columns,
          rows: _ctx.rows1,
          "select-options": {
          enabled: true,
          clearSelectionText: 'Annuler',
          selectionText: 'colis Sélectionnés',
        },
          onSelectedRowsChange: _ctx.selectionChanged,
          onSelectAll: _ctx.onSelectAll
        }, {
          emptystate: _withCtx(() => [
            _createVNode(_component_center, null, {
              default: _withCtx(() => _cache[33] || (_cache[33] = [
                _createTextVNode("Aucune entrées correspondants trouvés", -1)
              ])),
              _: 1,
              __: [33]
            })
          ]),
          "table-row": _withCtx((props) => [
            (props.column.field === 'code')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (props.row.replace == 1)
                    ? (_openBlock(), _createElementBlock("h6", _hoisted_22, [
                        _createTextVNode(_toDisplayString(props.row.code) + " ", 1),
                        _cache[34] || (_cache[34] = _createElementVNode("i", { class: "flaticon-refresh" }, null, -1))
                      ]))
                    : (props.row.partial == 1)
                      ? (_openBlock(), _createElementBlock("h6", _hoisted_23, [
                          _createTextVNode(_toDisplayString(props.row.code) + " ", 1),
                          _cache[35] || (_cache[35] = _createElementVNode("i", { class: "flaticon-corner-down-left" }, null, -1))
                        ]))
                      : (_openBlock(), _createElementBlock("h6", _hoisted_24, _toDisplayString(props.row.code), 1))
                ], 64))
              : (props.column.field === 'status')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (
                props.row.status == 'IN_PROGRESS' &&
                props.row.status_second &&
                _ctx.globalStore.globalHelper(props.row.status_second).name
              )
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "rounded-pill fs-13 badge text-bg-black custom-badge",
                          style: _normalizeStyle({
                '--dynamic-bg': _ctx.globalStore.globalHelper(
                  props.row.status_second
                ).code_color,
              })
                        }, _toDisplayString(_ctx.globalStore.globalHelper(props.row.status_second).name), 5))
                      : (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          class: "rounded-pill fs-13 badge text-bg-black custom-badge",
                          style: _normalizeStyle({ '--dynamic-bg': props.row.code_color })
                        }, _toDisplayString(props.row.s_name), 5))
                  ], 64))
                : (props.column.field === 'price')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      _createElementVNode("b", null, _toDisplayString(props.row.price), 1),
                      _cache[36] || (_cache[36] = _createTextVNode(" DH ", -1))
                    ], 64))
                  : (props.column.field === 'updated_at')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(_ctx.getDate(props.row.updated_at)), 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(props.formattedRow[props.column.field]), 1))
          ]),
          _: 1
        }, 8, ["columns", "rows", "onSelectedRowsChange", "onSelectAll"]),
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_29, [
                _createVNode(_component_PaginatorContent, {
                  pagination: _ctx.users1,
                  offset: 9,
                  onPaginate: _ctx.getRows1
                }, null, 8, ["pagination", "onPaginate"])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_30, [
      _cache[45] || (_cache[45] = _createElementVNode("div", { class: "card-header" }, [
        _createElementVNode("h5", null, "Liste des colis ajoutés")
      ], -1)),
      _createElementVNode("div", _hoisted_31, [
        _createElementVNode("div", _hoisted_32, [
          (_ctx.auth.can('ADD_BDIS'))
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-danger fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0",
                type: "button",
                onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.removeNewColis && _ctx.removeNewColis(...args))),
                disabled: _ctx.load_remove
              }, [
                (_ctx.load_remove)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_34, _cache[38] || (_cache[38] = [
                      _createElementVNode("span", { class: "visually-hidden" }, "Loading...", -1)
                    ])))
                  : _createCommentVNode("", true),
                _cache[39] || (_cache[39] = _createTextVNode(" Supprimer ", -1)),
                _cache[40] || (_cache[40] = _createElementVNode("i", { class: "flaticon-delete position-relative ms-5 fs-12" }, null, -1))
              ], 8, _hoisted_33))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_35, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            onInput: _cache[12] || (_cache[12] = ($event: any) => (_ctx.getRows2())),
            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.users2.searchTerm) = $event)),
            class: "form-control shadow-none text-black rounded-0",
            placeholder: "Chercher"
          }, null, 544), [
            [_vModelText, _ctx.users2.searchTerm]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_36, [
        _createElementVNode("div", _hoisted_37, [
          _createElementVNode("div", _hoisted_38, [
            _cache[41] || (_cache[41] = _createElementVNode("label", null, "Voir", -1)),
            _createVNode(_component_v_select, {
              modelValue: _ctx.users2.per_page,
              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.users2.per_page) = $event)),
              options: [10, 50],
              clearable: false,
              class: "per-page-selector d-inline-block mx-50",
              onInput: _cache[15] || (_cache[15] = ($event: any) => (_ctx.getRows2()))
            }, null, 8, ["modelValue"]),
            _createElementVNode("label", null, _toDisplayString(_ctx.users2.total) + " entités", 1)
          ])
        ]),
        _createVNode(_component_vue_good_table, {
          columns: _ctx.columns2,
          rows: _ctx.rows2,
          "select-options": {
          enabled: true,
          clearSelectionText: 'Annuler',
          selectionText: 'Colis sélectionnés',
        },
          onSelectAll: _ctx.onSelectAllColis,
          onSelectedRowsChange: _ctx.selectionChangedColis
        }, {
          emptystate: _withCtx(() => [
            _createVNode(_component_center, null, {
              default: _withCtx(() => _cache[42] || (_cache[42] = [
                _createTextVNode("Aucune entrées correspondants trouvés", -1)
              ])),
              _: 1,
              __: [42]
            })
          ]),
          "table-row": _withCtx((props) => [
            (props.column.field === 'code')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (props.row.replace == 1)
                    ? (_openBlock(), _createElementBlock("h6", _hoisted_39, [
                        _createTextVNode(_toDisplayString(props.row.code) + " ", 1),
                        _cache[43] || (_cache[43] = _createElementVNode("i", { class: "flaticon-refresh" }, null, -1))
                      ]))
                    : (props.row.partial == 1)
                      ? (_openBlock(), _createElementBlock("h6", _hoisted_40, [
                          _createTextVNode(_toDisplayString(props.row.code) + " ", 1),
                          _cache[44] || (_cache[44] = _createElementVNode("i", { class: "flaticon-corner-down-left" }, null, -1))
                        ]))
                      : (_openBlock(), _createElementBlock("h6", _hoisted_41, _toDisplayString(props.row.code), 1))
                ], 64))
              : (props.column.field === 'c_statut')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (
                props.row.status == 'IN_PROGRESS' &&
                props.row.status_second &&
                _ctx.globalStore.globalHelper(props.row.status_second).name
              )
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "rounded-pill fs-13 badge text-bg-black custom-badge",
                          style: _normalizeStyle({
                '--dynamic-bg': _ctx.globalStore.globalHelper(
                  props.row.status_second
                ).code_color,
              })
                        }, _toDisplayString(_ctx.globalStore.globalHelper(props.row.status_second).name), 5))
                      : (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          class: "rounded-pill fs-13 badge text-bg-black custom-badge",
                          style: _normalizeStyle({ '--dynamic-bg': props.row.code_color })
                        }, _toDisplayString(props.row.s_name), 5))
                  ], 64))
                : (props.column.field === 'received_time')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_42, _toDisplayString(_ctx.getDate(props.row.received_time)), 1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_43, _toDisplayString(props.formattedRow[props.column.field]), 1))
          ]),
          _: 1
        }, 8, ["columns", "rows", "onSelectAll", "onSelectedRowsChange"]),
        _createElementVNode("div", _hoisted_44, [
          _createElementVNode("div", _hoisted_45, [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_46, [
                _createVNode(_component_PaginatorContent, {
                  pagination: _ctx.users2,
                  offset: 9,
                  onPaginate: _ctx.getRows2
                }, null, 8, ["pagination", "onPaginate"])
              ])
            ])
          ])
        ])
      ])
    ])
  ], 64))
}